import { defineMessages } from 'react-intl'

const scope = 'app.components.BusinessZoneCount'

export default defineMessages({
  tooltips: {
    currentZone: {
      id: `${scope}.tooltips.currentZone`,
      defaultMessage: 'Number of {type}s in jurisdiction',
    },
    total: {
      id: `${scope}.tooltips.total`,
      defaultMessage: 'Total number of {type}s',
    },
  },
})
